import ApiService from "./api.service";
 
const OblastService = {
    GetAll(lang){
        return ApiService.get(`/Oblast/GetAll?lang=${lang}`)
    },
}
export default OblastService